<template>
    <b-card no-body>
        <h5 class="text-center my-1">Minimum ve Maksimum Yakıt Fiyatları</h5>
        <b-overlay :show="loading" opacity="0.2" rounded="sm" class="pb-1">
            <div class="table-responsive mb-0">
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th>Firma</th>
                            <th>Yakıt Tipi</th>
                            <th>Min. Fiyat (TL)</th>
                            <th>Max. Fiyat (TL)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(item) in items">
                            <tr v-for="(price,p_index) in item.FuelPrices" :key="item.FuelBrandName + p_index">
                                <td :rowspan="item.FuelPrices.length" v-if="p_index == 0" class="text-center">
                                    <img class="fuel-brand-img-stats" :src="getImage(item)" />
                                </td>
                                <td class="pl-50">{{price.FuelGroupName}}</td>
                                <td class="text-right">{{price.MinPrice}}</td>
                                <td class="text-right">{{price.MaxPrice}}</td>
                            </tr>
                        </template>
                        <tr v-if="!items.length">
                            <td colspan="4" class="text-center">Herhangi bir veri bulunamadı.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-overlay>
    </b-card>
</template>

<script>
import { BCard,BOverlay } from 'bootstrap-vue'
export default {
    components:{
        BCard,
        BOverlay,
    },
    props:{
        items:Array
    },
    data(){
        return{
            loading:false,
        }
    },
    methods:{
        getImage(item){
            return require('@/assets/images/petrol-brand/'+ item.FuelBrandCode +'.svg')
        },
        setLoading(bool){
            this.loading = bool
        },
    }
}
</script>

<style>
    .fuel-special-eq{
        height:30px;
    }
</style>